import { useMemo, Fragment, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { Image } from 'foundations-components/transitional/components/Image';
import { DownIcon, RightIcon, SprocketIcon } from 'foundations-assets';
import { Table } from 'foundations-components/transitional/components/Table';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import * as FieldTypes from '../constants/dataSync/FieldType';
import { View as FoundationsView } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FieldMappingsCaret = ({
  open
}) => open ? /*#__PURE__*/_jsx(FoundationsView, {
  as: "span",
  paddingInlineEnd: "400",
  children: /*#__PURE__*/_jsx(DownIcon, {
    size: "300",
    color: "do-not-use-calypso"
  })
}) : /*#__PURE__*/_jsx(FoundationsView, {
  as: "span",
  paddingInlineEnd: "400",
  children: /*#__PURE__*/_jsx(RightIcon, {
    size: "300",
    color: "do-not-use-calypso"
  })
});
/*
  For Ops Hub listings only
 */
function SharedDataCard({
  dataSync,
  iconUrl,
  name,
  onOpenToolTip,
  onToggleOpen,
  opsHub,
  showError,
  SyncIcon
}) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const {
    sync,
    target,
    data
  } = dataSync;
  const renderedFieldMappings = useMemo(() => {
    return [FieldTypes.DEFAULT, FieldTypes.CUSTOM].map(fieldType => {
      const mappings = dataSync.getFieldMappingsByType(fieldType);
      if (!mappings.length) {
        return null;
      }
      return /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx("tr", {
          "data-test-id": "field-mapping-dropdown",
          children: /*#__PURE__*/_jsx("td", {
            colSpan: 3,
            children: /*#__PURE__*/_jsx(Text, {
              typography: "body-125",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `marketplace-ui-apps-core.dataSyncs.fieldMappings.${fieldType}`
              })
            })
          })
        }), mappings.map((mapping, index) => {
          const isCustomMapping = mapping.fieldType === FieldTypes.CUSTOM;
          return /*#__PURE__*/_jsxs("tr", {
            "data-test-id": "field-mapping",
            children: [/*#__PURE__*/_jsx("td", {
              colSpan: isCustomMapping ? 3 : 1,
              children: mapping.appField
            }), !isCustomMapping && /*#__PURE__*/_jsxs(Fragment, {
              children: [/*#__PURE__*/_jsx("td", {}), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx(View, {
                  marginInlineStart: "400",
                  as: "span",
                  children: mapping.hubSpotField
                })
              })]
            })]
          }, `default-mapping-${index}`);
        })]
      }, fieldType);
    });
  }, [dataSync]);
  return /*#__PURE__*/_jsx(View, {
    borderColor: showError ? 'border-alert-default' : 'border-core-pressed',
    borderRadius: "100",
    borderStyle: "solid",
    borderWidth: showError ? '200' : '100',
    marginBlockEnd: "600",
    children: /*#__PURE__*/_jsx(CardWrapper, {
      "data-test-id": "shared-data-card",
      marginBlockEnd: "0",
      children: /*#__PURE__*/_jsxs(Table, {
        condensed: true,
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs(View, {
            as: "tr",
            backgroundColor: "fill-field-default",
            blockSize: "60px",
            cursor: opsHub ? 'pointer' : 'initial',
            "data-test-id": "data-sync-dropdown",
            onClick: () => {
              if (opsHub) {
                setDropdownOpen(!dropdownOpen);
                if (onToggleOpen) {
                  onToggleOpen();
                }
              }
            },
            children: [/*#__PURE__*/_jsx(View, {
              as: "th",
              inlineSize: "40%",
              children: /*#__PURE__*/_jsxs(TFlex, {
                align: "center",
                children: [opsHub && /*#__PURE__*/_jsx(FieldMappingsCaret, {
                  open: dropdownOpen
                }), /*#__PURE__*/_jsxs(TFlex, {
                  align: "center",
                  children: [iconUrl && /*#__PURE__*/_jsx(Image, {
                    inlineSize: "24px",
                    marginInlineEnd: "200",
                    src: iconUrl
                  }), /*#__PURE__*/_jsx(Text, {
                    typography: "heading-100",
                    textTransform: "none",
                    children: target
                  })]
                })]
              })
            }), /*#__PURE__*/_jsx(Tooltip, {
              onOpenChange: ({
                target: {
                  value: open
                }
              }) => {
                if (open && onOpenToolTip) {
                  onOpenToolTip();
                }
              },
              placement: "top",
              title: opsHub ? /*#__PURE__*/_jsx(FormattedMessage, {
                message: `marketplace-ui-apps-core.dataSyncs.sync.${sync}`
              }) : dataSync.description || /*#__PURE__*/_jsx(FormattedMessage, {
                message: `marketplace-ui-apps-core.detail.overview.sharedData.dataFlow${dataSync.sync}`,
                options: {
                  name
                }
              }),
              children: /*#__PURE__*/_jsx(View, {
                as: "th",
                inlineSize: "10%",
                paddingBlockStart: "300",
                children: /*#__PURE__*/_jsx(SyncIcon, {
                  sync: sync
                })
              })
            }), /*#__PURE__*/_jsx(View, {
              as: "th",
              inlineSize: "50%",
              children: /*#__PURE__*/_jsxs(TFlex, {
                align: "center",
                children: [/*#__PURE__*/_jsx(FoundationsView, {
                  as: "span",
                  marginBlockStart: "100",
                  marginInlineEnd: "200",
                  marginInlineStart: "400",
                  children: /*#__PURE__*/_jsx(SprocketIcon, {
                    color: "do-not-use-lorax",
                    size: "600"
                  })
                }), /*#__PURE__*/_jsx(Text, {
                  typography: "heading-100",
                  textTransform: "none",
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: `marketplace-ui-apps-core.dataSyncs.data.${data}`
                  })
                })]
              })
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: dropdownOpen && renderedFieldMappings
        })]
      })
    }, target)
  });
}
export default SharedDataCard;